import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { baseUrl } from "@/app/common/constants";

@Injectable({
  providedIn: "root",
})
export class HttpClientService {

  public constructor(private _httpClient: HttpClient) {

  }

  private _url(url: string): string {
    return `${baseUrl}${url}`;
  }

  /**
   * Send All the  GET request
   *
  */
  public _getRequest<T = Object>(url:string){

    return this._httpClient.get<T>(this._url(url));
  }


  /***
   * Send all the POST REQUEST
   *
  */

  public _postRequest<T = Object>(url:string,payload:any){
    return  this._httpClient.post<T>(this._url(url),payload);
  }

  /***
   * Send all the PUT REQUEST
   *
  */

  public _putRequest<T = Object>(url:string,payload:any){
    return  this._httpClient.put<T>(this._url(url),payload);
  }

  /***
   * Send all the DELETE REQUEST
   *
  */

  public _deleteRequest<T = Object>(url:string){
    return  this._httpClient.delete<T>(this._url(url));
  }

  public _postFormRequest<T = Object>(url: string, formData: FormData) {
    return this._httpClient.post<T>(this._url(url), formData);
  }

  /***
   * Send all the PATCH REQUEST
   *
  */

  public _patchRequest<T = Object>(url: string, payload: any) {
    return this._httpClient.patch<T>(this._url(url), payload);
  }

}
